import styles from "./Home.module.css";

import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import FormatTimestamp from "../utility/FormatTimestamp";

import * as config from "../config";
import OnlyAWSVideoPlayer from "../components/OnlyAWSVideoPlayer/OnlyAWSVideoPlayer";
import {GetCurrency, GetProductsFile, GetVideoFile} from "../utility/Utils";


// Function to fetch video data from the API
// This implementation is a bit lazy, as it parses for the matched
// video id client-side, but ideally the API should find and return
// the correct video given an id.

function NotFoundError() {
    return (
        <>
            <h1 className={styles.h1}>Error: Video not found</h1>
        </>
    );
}

function AWSVideo() {
    let {id} = useParams();

    const [videoViews] = useState(0);
    const [response, setResponse] = useState({});
    const [apiFetched, setApiFetched] = useState(false);

    const fetchAPI = async () => {

        const response2 = await fetch(GetProductsFile("demo",id));
        const details = await response2.json();
        console.log(details)


        const response = {}
        response['playbackUrl'] = GetVideoFile("demo",id)
        response['title'] = details["title"]
        response['subtitle'] = details["subtitle"]
        response['fps'] = details["fps"]
        response['currency'] = GetCurrency(details["currency"])
        response['length'] = '100'
        response['products'] = details["products"]

        setResponse(response);
        setApiFetched(true);

    }

    useEffect(() => {
        // Set mounted to true so that we know when first mount has happened
        let mounted = true;

        if (mounted && !apiFetched) {
            fetchAPI()
        }

        // Set mounted to false when the component is unmounted
        return () => {
            mounted = false
        };
    });

    function VideoMatched(props) {
        console.log(props, "sss")
        console.log(response['currency']
        )
        return (
            <>
                <OnlyAWSVideoPlayer
                    videoStream={props.playbackUrl}
                    controls={true}
                    muted={false}
                    onPlay={handleOnPlay}
                    data={props.data}
                    products={props.products}
                    currency={response['currency']}
                    fps={props.fps}
                    imageUrl={`${config.S3_URL}/demo/${id}`}
                />
            </>
        );
    }

    const handleOnPlay = () => {
    }

    return (
        <>
                {response ? (
                    <VideoMatched
                        title={response.title}
                        playbackUrl={response.playbackUrl}
                        subtitle={response.subtitle}
                        fps={response.fps}
                        views={videoViews}
                        data={response.data}
                        currency={response.currency}
                        products={response.products}
                        length={FormatTimestamp(response.length)}
                        onPlay={handleOnPlay}
                    />
                ) : (
                    <NotFoundError/>
                )}
        </>
    );
}

export default AWSVideo;
